import { Dispatch, SetStateAction, useState } from "react"
import { Plot } from "../../types"




export function StaticLegends({ plots, filteredLabels, setFilteredLabels }: { plots: Plot[], filteredLabels: string[], setFilteredLabels: Dispatch<SetStateAction<string[]>> }) {

    const [hoveredLabel, setHoveredLabel] = useState<number | null>(null);

    const filterData = (label: string) => {
        setFilteredLabels((labels: string[]) => {
            if (labels.includes(label)) {
                return labels.filter((l: string) => l !== label)
            }
            return [...labels, label]
        })
    }

    const isDeselected = (label: string): boolean => {
        return filteredLabels.includes(label);
    }

    const labelHovered = (idx: number): boolean => idx === hoveredLabel;

    console.log("plots: ", plots);
    return (
        <div className="p-4 px-6">
            <div className="flex justify-between w-full p-3 px-8 text-xs border rounded-lg shadow">
                {plots.filter(p => !!p).map((p: Plot, idx: number) =>
                    <div className=" relative flex items-center cursor-pointer" key={idx} onClick={() => filterData(p.label)} onMouseEnter={() => setHoveredLabel(idx)} onMouseLeave={() => setHoveredLabel(null)} >
                        <div
                            className={`h-3 w-4`}
                            style={{
                                backgroundColor: p.color,
                                opacity: isDeselected(p.label) ? 0.3 : 1,
                            }}
                        />
                        <div className="ml-2">{p.label}</div>
                        {isDeselected(p.label) ? <div className="absolute left-0 flex w-full  border-[0.5px] border-black"></div> : null}
                    </div>

                )}
            </div>
        </div>
    )




}